import { render, staticRenderFns } from "./tag-edit-modal.vue?vue&type=template&id=ef2bf480"
import script from "./tag-edit-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-edit-modal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports